// Keep in sync with devmain\translator\client\public\Translation.h
export enum ClientType {
    Undefined = 0,
    OWA,
    OutlookWin32,
}
